const { RichText } = wp.blockEditor;
import Inspector from './inspector';

const Edit = ({ attributes, setAttributes }) => {
  const { image, title, description } = attributes;
  const staticDefaultImage = 'https://via.placeholder.com/300x200';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className="SolutionSection-accordion-item">
        <figure className="SolutionSection-accordion-item-image margin-extra-small">
          <img
            className="SolutionSection-accordion-item-image"
            src={image.src || staticDefaultImage}
          />
        </figure>

        <div className="SolutionSection-accordion-item-content">
          <RichText
            tagName="h3"
            className="Typography subtitle left color-blue-dark margin-extra-small"
            value={title}
            placeholder="Título"
            keepPlaceholderOnFocus
            onChange={(title) => setAttributes({ title })}
          />

          <RichText
            tagName="p"
            className="Typography text left color-grey margin-none"
            value={description}
            placeholder="Descrição"
            keepPlaceholderOnFocus
            onChange={(description) => setAttributes({ description })}
          />
        </div>
      </div>
    </>
  );
};

export default Edit;
